export enum ModalDismissType {
  Backdrop = 'backdrop',
  Close = 'close',
  Success = 'success',
  Error = 'error',
}
